module.exports = __webpack_public_path__ + "img/autoamerics-original-1920.f6466b53.webp";